export default __webpack_public_path__ + "static/media/box.5878b63e.svg";